<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/126cPXF/tc-custom/9781614754572.jpg?1704798982262" alt="This image is the cover for the book Phule and His Money, Phule's Company"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Phule and His Money, Phule's Company
      </h1>
      <p class="bookDescription body article font2">
        <b>From a <i>New York Times </i>bestseller, a commander leads a legion of misfits as they create an amusement park on another planet in this sci-fi comedy.</b><br/>  <br/> Captain Willard Phule has whipped his troops into shape, turning Phule’s Company from the laughingstock of the Legion into . . . a crack team of casino security guards. Now his company is deployed to help an underdeveloped planet. And what better way to utilize their major area of expertise—goofing off—than to turn the planet into the biggest intergalactic playground ever?<br/>  <br/> Praise for the Phule’s Company series:<br/>  <br/> “A winning story . . . part science fiction, part spoof, part heart-warmer.” —<i>Publishers Weekly</i><br/>  <br/> “Madcap . . . a welcome sendup of military sf.” —<i>Booklist</i><br/>  <br/> “Light without being frivolous, and displays Asprin’s considerable expertise about fencing and things military, especially leadership.” —<i>Chicago Sun-Times</i><br/> “Reminiscent of ‘M*A*S*H.’” —<i>Analog Science Fiction and Fact Magazine</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Asprin, Peter J. Heck
      </h2>
      
      <p class="authorDescription body article">Robert Lynn Asprin was an American science fiction and fantasy author, best known for his Myth Adventures and Phule’s Company series. As an active fan of the genres, he was a member of the Society for Creative Anachronism, a co-founder of the Great Dark Horde, and founder of the Dorsai Irregulars. He was nominated for the Hugo Award for Best Dramatic Presentation for The Capture in 1976. Asprin died in 2008 at the age of 61 having published over fifty novels and several short stories. Peter Jewell Heck is an American science fiction and mystery author, best known for his “Mark Twain Mysteries” and Phule’s Company series.  He was an editor for Ace Books and is a regular reviewer for Asimov’s Science Fiction and Kirkus Reviews.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Word Fire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?225caf02